module.exports = __webpack_public_path__ + "static/media/Mitocondria v15 .f5be2fa3.glb";